<template>
  <div id="myDateShow">
    <div class="title">{{activityId?"修改":"新增"}} 营销活动</div>
    <div id="dataShow">
      <div class="line">
        <div class="key">活动类型</div>
        <div class="value">
          <el-select class="w500" v-model="activity.activityType" placeholder="请选择活动类型">
            <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="line">
        <div class="key">营销商户类型</div>
        <div class="value">
          <el-select class="w500" v-model="activity.marketingMerchantsType" placeholder="请选择营销商户类型">
            <el-option
                    v-for="item in options2"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="line">
        <div class="key">活动标题</div>
        <div class="value">
          <el-input class="w500" v-model="activity.activityTitle" placeholder="请填写活动标题"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">竞猜答案提示</div>
        <div class="value">
          <el-input class="w500" v-model="activity.activityAnswerTip" placeholder="请填写竞猜答案提示"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">活动开始时间</div>
        <div class="value">
          <el-date-picker
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="activity.activityStartDate"
                  type="datetime"
                  placeholder="选择活动开始日期时间">
          </el-date-picker>
        </div>
      </div>
      <div class="line">
        <div class="key">活动结束时间</div>
        <div class="value">
          <el-date-picker
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="activity.activityEndDate"
                  type="datetime"
                  placeholder="选择活动结束日期时间">
          </el-date-picker>
        </div>
      </div>
      <div class="line">
        <div class="key">活动中奖名单公布时间</div>
        <div class="value">
          <el-date-picker
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="activity.activityListPublishedDate"
                  type="datetime"
                  placeholder="选择活动中奖公布日期时间">
          </el-date-picker>
        </div>
      </div>
      <div class="line">
        <div class="key">活动规则</div>
        <div class="value">
          <el-input type="textarea"
                    :autosize="{ minRows: 4 }"
                    class="w500" v-model="activity.activityRule"
                    placeholder="请填写商户简介（100-300字为佳）"></el-input>
        </div>
      </div>
      <div class="line" v-if="activity.activityCreateTime">
        <div class="key">活动创建时间</div>
        <div class="value">
          {{activity.activityCreateTime}}
        </div>
      </div>
      <div class="line">
        <div class="key">活动海报</div>
        <div class="value">
          <img v-if="activity.activityImg" :src="activity.activityImg" alt="">
        </div>
      </div>
      <div class="line">
        <div class="key"></div>
        <div class="value">
          <el-upload
                  :headers="headers"
                  ref="upload"
                  :on-change="upLoad"
                  :on-success="upLoadSeccess"
                  class="upload-demo"
                  name="multipartFile"
                  drag
                  :action="baseURL+'/activity/upload'"
                  :auto-upload="false">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">重新上传活动海报</div>
          </el-upload>
        </div>
      </div>
      <div class="line">
        <div class="key">活动答案</div>
        <div class="value">
          <img v-if="activity.activityAnswerImg" :src="activity.activityAnswerImg" alt="">
        </div>
      </div>
      <div class="line">
        <div class="key"></div>
        <div class="value">
          <el-upload
                  :headers="headers"
                  ref="upload2"
                  :on-change="upLoadAnswer"
                  :on-success="upLoadAnswerSeccess"
                  class="upload-demo"
                  name="multipartFile"
                  drag
                  :action="baseURL+'/activity/upload'"
                  :auto-upload="false">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">重新上传活动海报</div>
          </el-upload>
        </div>
      </div>
      <div class="line">
        <div class="key">是否发布</div>
        <div class="value">
          <el-select class="w500" v-model="activity.isRelease" placeholder="是否发布">
            <el-option
                    v-for="item in options3"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="line">
        <div class="key"></div>
        <div class="value">
          <el-button type="primary" size="medium" @click="submit">提交信息</el-button>
        </div>
      </div>
      <div class="line"></div>
    </div>
    <div class="but">
      <el-button type="danger" size="small" @click="backClick">返回</el-button>
    </div>
  </div>
</template>

<script>
  import {getActivityById, newVue, updateActivity} from "../../network/activity";

  export default {
    name: "activityInsert",
    data(){
      return{
        activity: {},
        activityId: '',
        options: [
          {
            value:"竞猜",
            label:"竞猜"
          },
          {
            value:"盲盒抽奖",
            label:"盲盒抽奖"
          },
          {
            value:"津贴",
            label:"津贴"
          },
          {
            value:"心味汇",
            label:"心味汇"
          }
        ],
        options2: [
          {
            value:"自营发起",
            label:"自营发起"
          },
          {
            value:"联合商户",
            label:"联合商户"
          }
        ],
        options3: [
          {
            value:"是",
            label:"是"
          },
          {
            value:"否",
            label:"否"
          }
        ],

        authorization:"",
        headers: {
        },
        baseURL:newVue.baseURL
      }
    },
    created() {
      newVue.obj = this;
      this.authorization=newVue.obj.common.loginInfo.jwtToken;
      this.headers.Authorization = this.authorization;
      this.common.HeaderLocationTwo.href =  "/activity/list";
      this.common.HeaderLocationTwo.name = "营销俱乐部管理"
      this.common.HeaderLocationThree.name = "新增or修改营销活动"
      if (this.$route.params.id!=null){
        this.activityId = this.$route.params.id;

        getActivityById(this.activityId).then(res => {
          this.activity = res.data;
        })
      }

    },
    methods: {
      upLoadSeccess(res){
        this.activity.activityImg = res.data;
      },
      upLoadAnswerSeccess(res){
        this.activity.activityAnswerImg = res.data;
      },
      backClick(){
        this.$router.push("../list");
      },
      upLoad (file, fileList) {
        this.$refs.upload.submit()
      },
      upLoadAnswer (file, fileList) {
        this.$refs.upload2.submit()
      },
      submit(){
        updateActivity(this.activity).then(res => {
          console.log(res);
        })
      }
    }
  }
</script>

<style scoped>
  @import "../../assets/css/data.css";
  .w500{
    width: 500px;
  }
</style>
